export function getVideoUrlFromCloudflareId(id: string) {
  const fullURL = new URL(window.location.href);
  const baseURL = `${fullURL.protocol}//${fullURL.host}`;
  const dcDashboardVideoUrl = `${baseURL}/video/${id}`;
  return dcDashboardVideoUrl;
}
